import ReactDOM from 'react-dom';
import React from 'react';
import App from './components/App.jsx';


import '../style/style.scss';

 


ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./js/main.js